// @ts-strict-ignore
import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMContextService } from '@services/lm-context.service';
import { HttpClient } from '@angular/common/http';
import { LMUrlUtilService } from '@app/services';

@Component({
  selector:    'lm-access-denied-error',
  standalone: false,
  templateUrl: './lm-access-denied-error.html',
  styleUrls:   [ 'lm-access-denied-error.scss' ]
})

export class AccessDeniedErrorComponent implements OnInit {

  availableApps: Array<any>;
  signOutUrl: string;
  signOutString: string;
  message: string;
  title: string;
  lmErrorUtilService: LMErrorUtilService;

  constructor(
    private http: HttpClient,
    private lmContextService: LMContextService,
    @Inject(forwardRef(() => LMErrorUtilService)) lmErrorUtilService, // LMErrorUtilService
    private lmLoggerService: LMLoggerService,
    private lmUrlUtilService: LMUrlUtilService,

  ) {
    this.lmErrorUtilService = lmErrorUtilService as LMErrorUtilService;
  }

  ngOnInit() {
    const url = this.lmUrlUtilService.getAccessDeniedUrl();
    this.http.get(url).subscribe({
      next: (response: any) => {
        this.lmLoggerService.trace([ this, 'getAccessibleApps completed', 'apps: ' + response ]);
        this.title = response.noAccessString;
        this.message = response.accessibleWebAppString;
        this.signOutString = response.signOutString;
        this.availableApps = response.accessibleWebApps;
        this.signOutUrl = response.signOutUrl;
      },
      error: (error: any) => {
        const error2: LMError = { message: error.message, status: error.status, details: error.stack };
        this.lmErrorUtilService.handleUnexpectedError(error2);
      }
    });
  }

  // tslint:disable-next-line - method not used
  public navigateToApp(webApp: any): void {
    let url = webApp.webAppUrl;
    if (this.lmContextService.inMingleInbox()) {
      // Switch the web app name in the current url
      url = window.location.href;
      url = url.replace(this.lmContextService.getContext().webApp, webApp.webAppName);
    }
    // if navigating to a new app we must update our context with the new app and data area.
    this.lmContextService.getContext().webAppTitle = webApp.webAppTitle;
    this.lmContextService.getContext().webApp = webApp.webAppName;

    this.lmErrorUtilService.accessDeniedError$.next(true);

    // need to reload page to make sure context and menu is populated correctly

    window.location.href = url;
  }
}
